import * as React from 'react';
import { Modal, Button, Space, Typography } from 'antd';
import ReactDiffViewer from 'react-diff-viewer-continued';
import { ScriptRevision } from '../../types';
import { ScriptManagementStore } from '../../stores';
import { Utils } from '../../../common/services/Utils';
import { observer } from 'mobx-react-lite';

type Props = {
    store: ScriptManagementStore;
    visible: boolean;
    olderRevision: ScriptRevision | null;
    newerRevision: ScriptRevision | null;
    onClose: () => void;
};

const { Text } = Typography;

const RevisionComparisonModal: React.FC<Props> = ({ store, visible, olderRevision, newerRevision, onClose }) => {
    const [splitViewEnabled, setSplitViewEnabled] = React.useState(true);

    const toggleSplitView = () => {
        setSplitViewEnabled(prev => !prev);
    };

    if (!olderRevision || !newerRevision) {
        return null;
    }

    return (
        <Modal
            className="alpha-portal-dialog"
            bodyStyle={{ maxHeight: 'calc(100vh - 310px)' }}
            width={1200}
            visible={visible}
            title={`Compare Revisions: ${olderRevision.id} vs ${newerRevision.id}`}
            onCancel={onClose}
            footer={[
                <Button key="split-view-toggle" onClick={toggleSplitView}>
                    {splitViewEnabled ? 'Disable' : 'Enable'} split view
                </Button>,
                <Button key="back" type="primary" onClick={onClose}>
                    Close
                </Button>
            ]}
        >
            <div>
                <Space style={{ marginBottom: 8 }}>
                    <Text strong>Older:</Text>
                    <Text>
                        {Utils.formatDateStringShort(olderRevision.createDate)} -{' '}
                        {store.getUserNameById(olderRevision.createdBy)}
                    </Text>
                </Space>
                <br />
                <Space style={{ marginBottom: 16 }}>
                    <Text strong>Newer:</Text>
                    <Text>
                        {Utils.formatDateStringShort(newerRevision.createDate)} -{' '}
                        {store.getUserNameById(newerRevision.createdBy)}
                    </Text>
                </Space>
                <ReactDiffViewer
                    splitView={splitViewEnabled}
                    oldValue={olderRevision.body}
                    newValue={newerRevision.body}
                />
            </div>
        </Modal>
    );
};

export default observer(RevisionComparisonModal);
